import React from 'react';
import ModalHeader from '../molecules/ModalHeader';
import ModalFooter from '../molecules/ModalFooter';
import PassengerForm from '../molecules/PassengerForm';

/**
 * Step2PassengerData - Paso 2: Datos de pasajeros
 *
 * Props:
 * - maxPersons: Número máximo de personas/pasajeros
 * - passengers: Array de objetos con datos de pasajeros
 * - onChange: Función callback (index, fieldName, value) => void
 * - errors: Objeto con errores { passengers: [...] }
 * - onBack: Función callback para volver (opcional)
 * - onContinue: Función callback para continuar
 * - className: Clases CSS adicionales (opcional)
 */
function Step2PassengerData({
  maxPersons,
  passengers = [],
  onChange,
  errors = {},
  onBack,
  onContinue,
  className = ''
}) {
  // Generate array for the number of passengers based on maxPersons
  const passengerIndices = Array.from({ length: maxPersons }, (_, i) => i);

  return (
    <div className={`d-flex flex-column gap-2 rounded w-100 mx-auto ${className}`}>
      <ModalHeader
        title="Completa tu Información"
        subtitle="Datos del Pasajero"
        currentStep={1}
      />
      <div className="d-flex overflow-x-auto gap-3 pb-2">
        {passengerIndices.map((index) => (
          <div key={`passenger-${index}`} className="d-flex flex-column justify-content-center gap-1 w-100">
            {maxPersons > 1 && (
              <h3 className="fs-5 text-dark">
                Pasajero {index + 1}
              </h3>
            )}
            <PassengerForm
              key={`passenger-form-${index}`}
              index={index}
              passenger={passengers[index] || {
                lastName: '',
                firstName: '',
                birthDate: '',
                idType: 'cedula',
                idNumber: '',
                nationality: ''
              }}
              onChange={onChange}
              errors={errors.passengers?.[index] || {}}
              className={maxPersons === 1 ? 'w-100' : 'flex-shrink-0'}
              style={maxPersons > 1 ? {minWidth: '320px'} : {}}
            />
            {maxPersons === 1 && (
              <hr className="mt-2" />
            )}
          </div>
        ))}
      </div>
      <ModalFooter
        onBack={onBack}
        onContinue={onContinue}
        continueText="Continuar"
        backText="Atrás"
      />
    </div>
  );
}

export default Step2PassengerData;
